import {
  Badge,
  Box,
  Button,
  Flex,
  Group,
  Menu,
  Select,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBackUp,
  IconArrowNarrowRight,
  IconArrowsExchange,
  IconCheck,
  IconShieldCheck,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";

// Ô nhập Serial mới: giữ state cục bộ để gõ + uppercase mượt,
// chỉ commit vào data của bảng khi blur -> tránh re-render toàn bảng mỗi ký tự.
const SerialInput = React.memo(function SerialInput({
  value,
  onCommit,
}: {
  value: string;
  onCommit: (val: string) => void;
}) {
  const [localValue, setLocalValue] = useState(value ?? "");

  // Đồng bộ khi giá trị từ ngoài thay đổi (vd: đổi hình thức đổi trả)
  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  return (
    <TextInput
      placeholder="Serial nhập từ NCC"
      value={localValue}
      onChange={(e) => setLocalValue(e.currentTarget.value.toUpperCase())}
      onBlur={() => {
        if (localValue !== (value ?? "")) {
          onCommit(localValue);
        }
      }}
    />
  );
});

const InWardWarrantyVendor = ({
  back,
  dataRowProps,
  setDataRowProps,
  handleWarrantyInward,
  typeView,
}: {
  back: any;
  dataRowProps: any;
  setDataRowProps: any;
  handleWarrantyInward: any;
  typeView: string;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [data, setData] = useState<any>(dataRowProps);
  const [dataProduct, setDataProduct] = useState<any[]>([]);

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const checkAllFields = () => {
    const dataCheck = data.filter(
      (item: any) => item.formChange !== "KHONG_DOI",
    );

    return dataCheck.every(
      (item: any) =>
        item?.attribute5 &&
        item?.attribute5?.length > 0 &&
        item?.itemCode &&
        item?.itemCode?.length > 0,
    );
  };

  const confirmChangeSerial = () => {
    return data.every((item: any) => item.formChange === "KHONG_DOI");
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemTransactionHeaderCode",
        header: "Số phiếu xuất BH NCC",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue}
          </Badge>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "formChange",
        header: "Hình thức đổi",
        Cell: ({ row }) => (
          <Select
            placeholder="Hình thức đổi trả"
            data={[
              { label: "Không đổi", value: "KHONG_DOI" },
              { label: "Đổi tương đương", value: "DOI_TUONG_DUONG" },
              { label: "Đổi mới", value: "DOI_MOI" },
            ]}
            defaultValue={row.original.formChange}
            onChange={(e) => {
              handleChange(row.original.serial?.toString(), {
                formChange: e ? e : "KHONG_DOI",
                newItemCode: "",
                attribute5: null,
                attribute4: null,
                parentSerial: null,
              });
            }}
          />
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute21",
        header: "Số phiếu nhà cung cấp",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "newItemCode",
        header: "Mã sản phẩm mới",
        Cell: ({ row }) => {
          return row.original.formChange === "KHONG_DOI" ? (
            <Text fw={500} size="12.5px">
              {row.original.itemCode}
            </Text>
          ) : (
            <Menu width={800} trigger="hover">
              <Menu.Target>
                <TextInput
                  placeholder="Mã sản phẩm mới"
                  value={row.original.newItemCode}
                  onMouseEnter={() => {
                    getDataItem(
                      !row.original.newItemCode ? "" : row.original.newItemCode,
                    );
                  }}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value;
                    handleChange(row.original.serial?.toString(), {
                      newItemCode: newValue,
                    });
                    if (newValue.length > 3) {
                      getDataItem(newValue, row.original.serial);
                    }
                  }}
                />
              </Menu.Target>
              <Menu.Dropdown>
                <Table.ScrollContainer minWidth={500} mah={480} type="native">
                  <Table striped withTableBorder>
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th>Chọn</Table.Th>
                        <Table.Th>Mã sản phẩm</Table.Th>
                        <Table.Th>Tên sản phẩm</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {dataProduct &&
                        dataProduct.length > 0 &&
                        dataProduct?.map((item, index) => (
                          <Table.Tr key={index}>
                            <Table.Td>
                              <Button
                                variant="filled"
                                disabled={data.some(
                                  (i: any) =>
                                    String(i.newItemCode) ===
                                    String(item.itemCode),
                                )}
                                onClick={() => {
                                  handleChange(
                                    row.original.serial?.toString(),
                                    {
                                      attribute4: item.itemId,
                                      newItemCode: item.itemCode,
                                    },
                                  );
                                }}
                              >
                                {data.some(
                                  (i: any) =>
                                    String(i.newItemCode) ===
                                    String(item.itemCode),
                                )
                                  ? "Đã chọn"
                                  : "Chọn"}
                              </Button>
                            </Table.Td>
                            <Table.Td>{item.itemCode}</Table.Td>
                            <Table.Td>{item.itemName}</Table.Td>
                          </Table.Tr>
                        ))}
                    </Table.Tbody>
                  </Table>
                </Table.ScrollContainer>
              </Menu.Dropdown>
            </Menu>
          );
        },
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute5",
        header: "Serial mới",
        Cell: ({ row }) =>
          row.original.formChange === "KHONG_DOI" ? (
            <Text fw={500} size="12.5px">
              {row.original.serial}
            </Text>
          ) : (
            <SerialInput
              value={row.original.attribute5 ?? ""}
              onCommit={(val) =>
                handleChange(row.original.serial?.toString(), {
                  attribute5: val,
                })
              }
            />
          ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      // {
      //   accessorKey: "attribute6",
      //   header: "Hạn BH mới",
      //   Cell: ({ row }) =>
      //     row.original.formChange === "KHONG_DOI" ? (
      //       <></>
      //     ) : (
      //       <NumberInput
      //         placeholder="Hạn BH mới"
      //         hideControls
      //         min={0}
      //         max={36}
      //         suffix=" tháng"
      //         allowNegative={false}
      //         onChange={(e) =>
      //           handleChange(row.original.serial?.toString(), {
      //             attribute6: e,
      //           })
      //         }
      //       />
      //     ),
      //   enableSorting: false,
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm cũ",
        Cell: ({ row }) => (
          <TextInput
            variant="unstyled"
            defaultValue={row.original.itemCode}
            readOnly
          />
        ),
        size: 100,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "serial",
        header: "Serial cũ",
        Cell: ({ row }) => (
          <TextInput
            variant="unstyled"
            defaultValue={row.original.serial}
            readOnly
          />
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "parentSerial",
        header: "Serial con",
        Cell: ({ row }) =>
          row.original.formChange === "KHONG_DOI" ? (
            <Text fw={500} size="12.5px"></Text>
          ) : (
            <SerialInput
              value={row.original.parentSerial ?? ""}
              onCommit={(val) =>
                handleChange(row.original.serial?.toString(), {
                  parentSerial: val,
                })
              }
            />
          ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ row }) => (
          <Box w={275}>
            <Tooltip label={row.original.itemName}>
              <Text size="12.5px" fw={500} truncate="end" h={15}>
                {row.original.itemName}
              </Text>
            </Tooltip>
          </Box>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        Cell: ({ row }) => (
          <TextInput
            placeholder="Ghi chú"
            onChange={(e) =>
              handleChange(row.original.serial?.toString(), {
                note: e.currentTarget.value,
              })
            }
          />
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
    ],
    [data, dataProduct],
  );

  const handleChange = (serial: string, updates: Record<string, any>) => {
    const updatedData = data.map((item: any) =>
      item.serial?.toString() === serial?.toString()
        ? {
            ...item,
            ...updates,
          }
        : item,
    );
    setData(updatedData);
    setDataRowProps(updatedData);
  };

  const handleConfirmChangeSerial = async () => {
    const changedItems = data.filter(
      (item: any) => item.formChange && item.formChange !== "KHONG_DOI",
    );
    const countDoiMoi = changedItems.filter(
      (i: any) => i.formChange === "DOI_MOI",
    ).length;
    const countTuongDuong = changedItems.length - countDoiMoi;

    // BHMR: gói đang kích hoạt trên serial cũ sẽ chuyển sang serial mới khi lưu phiếu.
    // Tra bằng scan-serial (trả bhmrPackages); không tra được thì bỏ qua, popup vẫn mở như cũ
    const bhmrBySerial: Record<
      string,
      { cardItemCode: string; cardSerial: string }[]
    > = {};
    const oldSerials: string[] = Array.from(
      new Set(
        changedItems
          .map((item: any) => String(item.serial ?? "").trim())
          .filter((serial: string) => serial.length > 0),
      ),
    );
    open();
    try {
      await Promise.all(
        oldSerials.map(async (serial) => {
          try {
            const res: any = await repositoryPos.get(
              `/api/v1/TblWarrantyItem/scan-serial?Serial=${encodeURIComponent(serial)}`,
            );
            const packages = res?.success ? res.data?.bhmrPackages : null;
            if (packages?.length) bhmrBySerial[serial.toUpperCase()] = packages;
          } catch {
            // không tra được gói của serial này
          }
        }),
      );
    } finally {
      close();
    }
    const packagesOf = (item: any) =>
      bhmrBySerial[String(item.serial ?? "").trim().toUpperCase()] ?? [];
    const countBhmr = changedItems.filter(
      (item: any) => packagesOf(item).length > 0,
    ).length;

    modals.openConfirmModal({
      title: (
        <Group gap={8}>
          <IconArrowsExchange size={20} color={green.base} />
          <Title order={5}>Xác nhận thay đổi serial</Title>
        </Group>
      ),
      centered: true,
      size: "lg",
      children: (
        <Box pb={8} pt={4}>
          <Text size="lg" fw={600} ta="center">
            Bạn có chắc chắn các thông tin đã nhập là chính xác?
          </Text>
          <Text size="xs" c="dimmed" ta="center" mt={4} mb="sm">
            Có {changedItems.length} serial sẽ được ghi nhận thay đổi trong
            phiếu nhập kho bảo hành NCC.
          </Text>

          {changedItems.length > 0 && (
            <Box
              p="md"
              style={{
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                backgroundColor: "#f8fafc",
              }}
            >
              <Group
                justify="space-between"
                align="center"
                pb={5}
                gap="md"
                wrap="nowrap"
              >
                <Text fw={600} c="blue" size="sm">
                  Danh sách sản phẩm thay đổi:
                </Text>
                <Group gap={8} wrap="nowrap">
                  {countBhmr > 0 && (
                    <Badge color="teal" variant="light" size="sm" radius="sm">
                      Chuyển gói BHMR: {countBhmr}
                    </Badge>
                  )}
                  {countDoiMoi > 0 && (
                    <Badge color="red" variant="light" size="sm" radius="sm">
                      Đổi mới: {countDoiMoi}
                    </Badge>
                  )}
                  {countTuongDuong > 0 && (
                    <Badge color="orange" variant="light" size="sm" radius="sm">
                      Đổi tương đương: {countTuongDuong}
                    </Badge>
                  )}
                </Group>
              </Group>

              <Table.ScrollContainer minWidth={520} mah={300} type="native">
                <Table
                  withTableBorder
                  withColumnBorders
                  highlightOnHover
                  bg="white"
                  verticalSpacing="sm"
                  horizontalSpacing="md"
                  layout="fixed"
                >
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Sản phẩm cũ (Serial)</Table.Th>
                      <Table.Th w={190} ta="center">
                        Hình thức
                      </Table.Th>
                      <Table.Th>Sản phẩm mới (Serial)</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {changedItems.map((item: any, idx: number) => (
                      <Table.Tr key={idx}>
                        <Table.Td>
                          <Text size="sm" fw={500}>
                            {item.itemCode}
                          </Text>
                          <Text size="xs" c="dimmed" mt={2}>
                            SN: {item.serial}
                          </Text>
                          {packagesOf(item).map((pkg) => (
                            <Group key={pkg.cardSerial} gap={4} mt={4} wrap="nowrap">
                              <IconShieldCheck size={14} color="var(--mantine-color-teal-7)" />
                              <Text size="xs" c="dimmed">
                                Gói BHMR {pkg.cardItemCode} (thẻ {pkg.cardSerial})
                              </Text>
                            </Group>
                          ))}
                        </Table.Td>
                        <Table.Td style={{ verticalAlign: "middle" }}>
                          <Flex direction="column" align="center" gap={6}>
                            <Badge
                              color={
                                item.formChange === "DOI_MOI" ? "red" : "orange"
                              }
                              variant="light"
                              size="sm"
                              radius="sm"
                              px={10}
                              styles={{
                                root: { maxWidth: "none" },
                                label: {
                                  overflow: "visible",
                                  textOverflow: "clip",
                                  whiteSpace: "nowrap",
                                },
                              }}
                            >
                              {item.formChange === "DOI_MOI"
                                ? "Đổi mới"
                                : "Đổi tương đương"}
                            </Badge>
                            <IconArrowNarrowRight size={16} color="#94a3b8" />
                          </Flex>
                        </Table.Td>
                        <Table.Td>
                          <Text size="sm" fw={500} c={green.base}>
                            {item.newItemCode || item.itemCode}
                          </Text>
                          <Text size="xs" c="dimmed" mt={2}>
                            SN: {item.attribute5}
                          </Text>
                          {item.parentSerial && (
                            <Text size="xs" c="dimmed" mt={2}>
                              Serial con: {item.parentSerial}
                            </Text>
                          )}
                          {packagesOf(item).map((pkg) => (
                            <Group key={pkg.cardSerial} gap={4} mt={4} wrap="nowrap">
                              <IconShieldCheck size={14} color="var(--mantine-color-teal-7)" />
                              <Text size="xs" fw={500} c="teal.7">
                                Nhận gói BHMR {pkg.cardItemCode}
                              </Text>
                            </Group>
                          ))}
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                </Table>
              </Table.ScrollContainer>
            </Box>
          )}

          <Text ta="center" size="sm" fs="italic" c="red" fw={500} mt="md">
            *Lưu ý: Phiếu nhập sẽ không thể sửa khi ấn "Đồng ý".
          </Text>
          {changedItems.length > 0 && (
            <Text
              ta="center"
              size="sm"
              fs="italic"
              c="yellow.8"
              fw={500}
              mt={4}
            >
              *Lưu ý cần làm đổi mã ở trên hệ thống Asia (nếu có)
            </Text>
          )}
          {countBhmr > 0 && (
            <Text
              ta="center"
              size="sm"
              fs="italic"
              c="teal.7"
              fw={500}
              mt={4}
            >
              *Gói BHMR đang kích hoạt trên serial cũ sẽ chuyển sang serial mới,
              giữ nguyên ngày kích hoạt.
            </Text>
          )}
        </Box>
      ),
      labels: { confirm: "Đồng ý", cancel: "Hủy" },
      cancelProps: { variant: "default" },
      confirmProps: {
        color: "teal",
        leftSection: <IconCheck size={18} />,
      },
      onConfirm: async () => {
        open();
        try {
          await handleWarrantyInward();
        } finally {
          close();
        }
      },
    });
  };

  const handleSave = () => {
    if (
      data.filter((i: any) => !i.attribute4 && i.formChange !== "KHONG_DOI")
        .length > 0
    ) {
      NotificationExtension.Fails(
        `Mã sản phẩm đổi mới của serial ${data
          .filter((i: any) => !i.attribute4)
          .map((i: any) => i.serial)
          .join(", ")} không tồn tại trong hệ thống !`,
      );
    } else if (checkAllFields()) {
      if (confirmChangeSerial()) {
        handleWarrantyInward();
      } else {
        handleConfirmChangeSerial();
      }
    } else {
      NotificationExtension.Fails(
        "Thông tin sản phẩm nhập về từ NCC chưa đầy đủ !",
      );
      return;
    }
  };

  const getDataItem = async (keySearch: any, serialChange?: string) => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblItem/get-list?Take=25&KeySearch=${keySearch}`,
    );

    if (res && res?.success) {
      const result = res.data;
      setDataProduct(result);

      if (
        result.some(
          (i: any) => String(i.itemCode).trim() === String(keySearch).trim(),
        ) &&
        serialChange &&
        serialChange.length > 0
      ) {
        const dataChange = result.find(
          (i: any) => String(i.itemCode).trim() === String(keySearch).trim(),
        );

        handleChange(serialChange?.trim() || "", {
          attribute4: dataChange.itemId,
          newItemCode: dataChange.itemCode.trim(),
        });
      } else {
        handleChange(serialChange?.trim() || "", {
          attribute4: null,
          newItemCode: null,
        });
      }
    }
  };

  useEffect(() => {
    getDataItem("");
  }, []);

  useEffect(() => {
    setData(
      dataRowProps.filter(
        (value: any, index: any, self: any) =>
          index ===
          self.findIndex(
            (t: any) => JSON.stringify(t) === JSON.stringify(value),
          ),
      ),
    );
  }, [dataRowProps]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data: data,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "transactionNumber"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box>
      <Group
        justify="space-between"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Badge
          variant="gradient"
          gradient={{ from: "blue", to: "cyan", deg: 90 }}
        >
          Nhập kho bảo hành NCC
        </Badge>
        <Flex gap="md">
          <Button
            type="button"
            color="red"
            loading={visible}
            onClick={() => back(false)}
            leftSection={!visible ? <IconArrowBackUp size={18} /> : undefined}
          >
            Quay lại
          </Button>
          <Button
            color="teal"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
            onClick={() => {
              if (
                typeView === "KHO" &&
                data.some((i: any) => i.formChange === "DOI_MOI")
              ) {
                modals.openConfirmModal({
                  title: <Title order={5}>Thông báo</Title>,
                  size: "auto",
                  children: (
                    <Text size="24px" fw={500} my={10}>
                      Vui lòng truy cập Asia thực hiện đổi mã sản phẩm !
                    </Text>
                  ),
                  labels: { confirm: "Tiếp tục", cancel: "Hủy bỏ" },
                  onConfirm: () => handleSave(),
                });
                return;
              }
              handleSave();
            }}
          >
            Lưu
          </Button>
        </Flex>
      </Group>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default InWardWarrantyVendor;
